export default __webpack_public_path__ + "static/cashflow_new_10-57a927d62f1c1c49924dd406f8f83f58.jpg";